<button
  class="marketing-button"
  [class.large]="!onMarketingLandingPage"
  [class.marketing-secondary]="secondaryStyle"
  (click)="onClick(actionButton)"
>
  {{ buttonText }}
</button>
